import { PaymentCard } from '../payment-card';
import { PaymentMethod as PaymentMethodAPI, PaymentMethodType as PaymentMethodTypeAPI } from '@vendasta/billing';
import { PaymentMethodType } from '../retail-customer-configuration';
import { convertApiPaymentCardDetails } from '../payment-card/payment-card';

export interface PaymentACHDebit {
  lastFourDigits: string;
  id: string;
}

export interface PaymentACSSDebit {
  lastFourDigits: string;
  id: string;
}

export type PaymentMethodDetails = PaymentCard | PaymentACHDebit | PaymentACSSDebit;

export interface PaymentMethod {
  type: PaymentMethodType;
  details?: PaymentMethodDetails;
  default: boolean;
  expired: boolean;
}

function isCardExpired(expiryYear: number, expiryMonth: number): boolean {
  if (!expiryYear || !expiryMonth) {
    return false;
  }
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  return expiryYear < currentYear || (expiryYear === currentYear && expiryMonth < currentMonth);
}

export function convertPaymentMethodFromApi(paymentMethod: PaymentMethodAPI): PaymentMethod {
  switch (paymentMethod.type) {
    case PaymentMethodTypeAPI.PAYMENT_METHOD_TYPE_CARD: {
      const details = paymentMethod.card ? convertApiPaymentCardDetails(paymentMethod.card) : undefined;
      return {
        type: PaymentMethodType.CARD,
        details,
        default: paymentMethod.default || false,
        expired: details ? isCardExpired(details.expiryYear, details.expiryMonth) : false,
      };
    }
    case PaymentMethodTypeAPI.PAYMENT_METHOD_TYPE_ACH_DEBIT: {
      return {
        type: PaymentMethodType.ACH_DEBIT,
        details: paymentMethod.achDebit,
        default: paymentMethod.default || false,
        expired: false,
      };
    }
    case PaymentMethodTypeAPI.PAYMENT_METHOD_TYPE_ACSS_DEBIT: {
      return {
        type: PaymentMethodType.ACSS_DEBIT,
        details: paymentMethod.acssDebit,
        default: paymentMethod.default || false,
        expired: false,
      };
    }
    default:
      return {
        type: PaymentMethodType.UNSET,
        default: paymentMethod.default || false,
        expired: false,
      };
  }
}
